/**
 * useScope Hook
 *
 * Consumes the ScopeContext to manage context switching between Personal and Managed scopes.
 * This is the hook that components should use to access scope state and actions.
 *
 * - Personal Scope: User's own data (no mentorId)
 * - Managed Scope: Data created by mentor for client (has mentorId)
 */

import { useContext } from "react";
import { ScopeContext } from "../components/scope/ScopeContext";

export const useScope = () => {
  const context = useContext(ScopeContext);

  if (!context) {
    // Return a default "personal scope" if context is not available
    // This allows the hook to be used even outside ScopeProvider during initial render
    console.warn(
      "useScope: ScopeContext not found, returning default personal scope"
    );
    return {
      isManaged: false,
      effectiveUserId: null,
      mentorId: null,
      clientName: null,
      actualUserId: null,
      isClientView: false,
      enterManagedScope: () => console.error("ScopeProvider not found"),
      enterClientViewScope: () => console.error("ScopeProvider not found"),
      exitManagedScope: () => {},
      getRole: () => "regularUser",
    };
  }

  return context;
};

export default useScope;
